/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { addBarcodes } from "../utils/addBarcodes";
import BarcodeReader from "react-barcode-reader";
import SolidButton from "../components/buttons/solid-button/SolidButton";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../components/hero/Banner";
import Header from "../components/header/Header";
import Container from "../components/container/Container";
import SuccessFlash from "../components/flash_message/SuccessFlash";
import ErrorFlash from "../components/flash_message/ErrorFlash";
import FormValidationError from "../components/flash_message/FormValidationError";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { playBeepingSound } from "../utils/playSound";
import ModalDrop from "../components/modals/ModalDrop";
import ScanError from "../components/scanning-error/ScanError";
import moment from "moment";
import { Keypad } from "react-number-pin-keypad";
import "./mobile-keypad.css";

const SetChildren = styled.div`
	margin-top: 5px;
	width: 100%;
`;
const Middle = styled.div`
	margin-top: 5px;
	width: 100%;
`;
const Input = styled.input`
	width: ${(props) => props.width};
	border: 1px solid #d6d6d6;
	color: black;
	font-size: 16px;
	border-radius: 5px;
	height: 40px;
	padding: 0 5px;
`;
const Label = styled.label`
	width: 100%;
	color: #8a8a8a;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0px;
	text-align: left;
`;
const FormInputControl = styled.div`
	width: 100%;
	margin: 10px 0;
`;

function PackPackage() {
	const axiosprivate = useAxiosPrivate();
	const location = useLocation();
	const { auth, setLoading, loading } = useAuth();
	const [barcode, setBarcode] = useState("Scan barcode...................");
	const [longitude, setLongitude] = useState("");
	const [latitude, setLatitude] = useState("");
	const [isSuccess, setIsSuccess] = useState(false);
	const [isFail, setIsFail] = useState(false);
	const navigate = useNavigate();
	const [isParent, setIsParent] = useState(true);
	const [childrenSet, setChildrenSet] = useState(0);
	const [childrenIsSet, setChildrenIsSet] = useState(false);
	const [parentCount, setParentCount] = useState(0);
	const [childrenCount, setChildrenCount] = useState(0);
	const [parent, setParent] = useState([]);
	const [children, setChildren] = useState([]);
	const [message, setMessage] = useState("Success");
	const [incompleteScan, setIncompleteScan] = useState(false);
	const [scanError, setScanError] = useState({ show: false, barcode: "" });
	useEffect(() => {
		childrenCount == childrenSet && childrenCount != 0 && handleSubmit();
	}, [childrenCount, childrenSet]);

	//clear out scan box
	useEffect(() => {
		setTimeout(() => {
			setBarcode("Scan barcode...................");
		}, 1000);
		return () => {
			clearTimeout();
		};
	}, [barcode]);

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			if (resp.state === "granted") {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				navigate("/", { state: { from: location }, replace: true });
			}
		});

		function success(position) {
			setLatitude(`${position.coords.latitude}`);
			setLongitude(`${position.coords.longitude}`);
		}

		function error(err) {
			console.error(err);
			navigate("/", { state: { from: location }, replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const validateCode = async (elementString) => {
		const clientId = auth.user.clientId || 4;
		return await axiosprivate.get(
			`/gs1/standard/label/check/${clientId}/${elementString}/pack`,
		);
	};

	const handleScan = async (data) => {
        if (loading || scanError.show) return;
		setIncompleteScan(false);
		setBarcode(data);
		setIsFail(false);
		setIsSuccess(false);
        setLoading(true);

		await validateCode(data)
			.then(() => {
                setLoading(false);
				if (isParent) {
					//check if label is SSCC
					if (
						data.substring(0, 2) === "00" &&
						data.substring(3, 6) === "615"
					) {
						if (data.length < 20) {
							setIncompleteScan(true);
							return;
						} else {
							setParent([...parent, data]);
							setParentCount(1);
							setIsParent(false);
							return;
						}
					} else {
						setIncompleteScan(true);
						setScanError({
							show: true,
							errorMessage:
								"You cannot scan SGTIN as a parent, please scan SSCC label",
							barcode: data,
						});
						playBeepingSound();
					}
				} else {
					//check if label is SSCC
					if (
						data.substring(0, 2) === "00" &&
						data.substring(3, 6) === "615"
					) {
						if (data.length < 20) {
							setIncompleteScan(true);
							return;
						} else {
							//check if SSCC is  pack into SGTIN
							if (parent[0].startsWith("01")) {
								setScanError({
									show: true,
									errorMessage:
										"You are trying to Pack SSCC INTO SGTIN",
									barcode: data,
								});
								playBeepingSound();
							}
							let filteredArray = addBarcodes(data, children);
							setChildrenCount(filteredArray.length);
							setChildren([...filteredArray]);
							return;
						}
					} else {
						if (data.length < 40) {
							setIncompleteScan(true);
							return;
						} else {
							let filteredArray = addBarcodes(data, children);
							setChildrenCount(filteredArray.length);
							setChildren([...filteredArray]);
							return;
						}
					}
				}
			})
			.catch((error) => {
                setLoading(false);
				console.error({ error });
				setScanError({
					show: true,
					errorMessage: "Label is faulty, kindly use another label",
					barcode: data,
				});
				playBeepingSound();
			});
	};

	//handle error
	function handleError(err) {
		console.error(err);
	}

	//Endpoint to pack
	const packPackage = async (data) => {
		return await axiosprivate.post("/gs1/standard/label/pack", data);
	};

	const resetScanError = () => {
		setScanError({ show: false, errorMessage: "", barcode: "" });
	};

	//query to send to backend
	const { mutate, isLoading } = useMutation(
		(variables) => packPackage(variables),
		{
			onSuccess() {
				setIsParent(true);
				setChildrenCount(0);
				setParentCount(0);
				setParent([]);
				setChildren([]);
				setIsSuccess(true);
				setMessage("Success");
			},
			onError(error) {
				setIsParent(true);
				setChildrenCount(0);
				setParentCount(0);
				setParent([]);
				setChildren([]);
				setIsFail(true);
				if (error.code === "ERR_NETWORK")
					setMessage("Please Check Your Network");
				else if (
					error?.response?.status === 403 ||
					error?.response?.status === 401
				)
					navigate("/", { state: { from: location }, replace: true });
				else {
					const message = error.response.data.message;
					if (message.includes("SQL")) {
						setMessage("Server Error");
					} else {
						setMessage(message?.replace("Unknow", "Unknown"));
					}
				}
			},
		},
	);

	//handle submit
	const handleSubmit = () => {
		const offset = moment().format("Z");
		const payload = {
			clientId: auth.user.clientId || 4,
			eventObjectParameter: {
				eventTime: new Date().toISOString().replace("Z", ""),
				recordTime: new Date().toISOString().replace("Z", ""),
				readPoint: auth.user.location,
				latitude: latitude,
				longitude: longitude,
				bizStep: "urn:epcglobal:cbv:bizstep:packing",
				disposition: "urn:epcglobal:cbv:disp:active",
				timeZone: offset,
			},
			packingData: {
				parent: parent[0],
				children: children,
			},
		};
		mutate(payload);
	};
	const confirmChildrenSet = () => {
		setChildrenIsSet(true);
	};

    const handleKeyPress = (key) => {
		setChildrenSet((prev) => prev + key);
	};

	const handleBackspace = () => {
		setChildrenSet((prevInput) => String(prevInput).slice(0, -1));
	};
	useEffect(() => {
		setLoading(isLoading);
	}, [isLoading, setLoading]);
	return (
		<Container>
			{scanError.show && (
				<ModalDrop>
					<ScanError
						onClose={resetScanError}
						barCode={scanError.barcode}
						errorMessage={scanError.errorMessage}
					/>
				</ModalDrop>
			)}
			<Header>{"Pack Package"}</Header>
			<Banner />

			<div>
				<small
					style={{
						fontSize: "12px",
						marginTop: "8px",
						display: "block",
					}}
				>
					Please set the total number of items (children) to be packed
					first, then scan the parent package, before scanning the
					children packages.
				</small>
			</div>
			<SetChildren>
				<FormInputControl>
					<Label>Set Children Quantity</Label>
				</FormInputControl>
				<FormInputControl>
					<Input
						width={"100%"}
						value={childrenSet}
						disabled={childrenIsSet}
						type="number"
						readOnly
						inputMode="none"
						onChange={(e) => setChildrenSet(e.target.value)}
						min={0}
					/>
					{!childrenIsSet && (
						<Keypad
							onKeyPress={handleKeyPress}
							onBackspace={handleBackspace}
							className="keypad-container"
						/>
					)}
				</FormInputControl>
				{!childrenIsSet && childrenSet > 0 && (
					<FormInputControl style={{ marginTop: "20px" }}>
						<SolidButton
							width={"100%"}
							text={"OK"}
							onclick={confirmChildrenSet}
						/>
					</FormInputControl>
				)}
			</SetChildren>
			{childrenIsSet && (
				<Middle>
					<BarcodeReader
						timeBeforeScanTest={1000}
						onError={handleError}
						onScan={handleScan}
					/>
					<FormInputControl>
						<Label>
							{isParent ? "Scan Parent" : "Scan Children"}
						</Label>
					</FormInputControl>
					<FormInputControl>
						<Input
							value={barcode}
							width={"100%"}
							style={{ fontSize: "12px" }}
							disabled
						/>
						{incompleteScan && (
							<FormValidationError
								text={"Incomplete scan.. please rescan!!!!"}
							/>
						)}
					</FormInputControl>
					<FormInputControl>
						<Label>Parent Count</Label>
					</FormInputControl>
					<FormInputControl>
						<Input
							width={"100%"}
							value={parentCount}
							disabled
							type="number"
						/>
					</FormInputControl>
					{parentCount > 0 && (
						<>
							<FormInputControl>
								<Label>Children Count</Label>
							</FormInputControl>
							<FormInputControl>
								<Input
									width={"100%"}
									value={childrenCount}
									disabled
									type="number"
								/>
							</FormInputControl>
						</>
					)}
				</Middle>
			)}

			<FormInputControl style={{ marginTop: "20px" }}>
				<SuccessFlash display={isSuccess}>{message}</SuccessFlash>
			</FormInputControl>

			<FormInputControl style={{ marginTop: "20px" }}>
				<ErrorFlash display={isFail}>{message}</ErrorFlash>
			</FormInputControl>
		</Container>
	);
}

export default PackPackage;
